(ns ycweb.components.transitions
  (:require
   #?@(:clj
       [[clojure.core.async :as async]]
       :cljs
       [[cljs.core.async :as async]])
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as u]
   [ycweb.util.comms :as comms]))


(defonce flow-state
  (atom {}))

;; Setup a one-by-one flow-dispatch for screen change events.
(defonce flow-dispatch (async/chan))
(defonce dispatch-loop-block
  (async/go-loop []
    (let [m (async/<! flow-dispatch)]
      (cond
        (nil? m) nil
        (fn? m)
        (do
          (m)
          (recur))
        :else
        (recur)))))


(defn back-history [history]
  (if (> (count history) 1)
    (butlast history)
    history))

(defn add-history [history new]
  (if (nil? new)
    (back-history history)
    (loop [[head & tail] history
           result []]
      (cond
        (nil? head) (conj result new)
        (= head new) (conj result head)
        :else (recur tail (conj result head))))))

(defmulti transition-open (fn [app-atom screen screen-params] screen))
(defmethod transition-open :default [app-atom screen screen-params])

(defmulti transition-close (fn [_ screen] screen))
(defmethod transition-close :default [app-atom screen])

(defmulti confirm-leave? (fn [app-atom screen] screen))
(defmethod confirm-leave? :default [app-atom screen] false)

(defmulti transition-after-open (fn [_ screen] screen))
(defmethod transition-after-open :default [app-atom screen])

(defn transition-mount [app-atom]
  #?(:cljs
     (let [screen (get-in @app-atom [:page :screen])]
       (transition-after-open app-atom screen))))

(defn transition-next [app-atom screen]
  (println "Transition to: " screen)
  ;;Since there is no lifecycle implemented in POS
  ;;We're implementing a bit of a workaround to close presence automatically 
  ;;if you're navigating away from the current screen you're in
  ;;You can think of the screen as the current process
  (let [{:keys [selected-warehouse blitz?]} @app-atom
        screen-atom (rum/cursor-in app-atom [:page :screen])
        s @screen-atom
        current-screen (when s (or (namespace s) s))
        new-screen (when screen (or (namespace screen) screen))]
    (when-not (= new-screen current-screen)
      (cond
        (and
          blitz?
          (= current-screen "packing")
          (not= new-screen "packing"))
        (let [lref
              {:ent/uuid (u/uuid (:warehouse-uuid selected-warehouse))
               :context/type :warehouse}
              presence-atom (rum/cursor app-atom :presence)
              {:keys [opened current-context]} @presence-atom
              packdesk-atom (rum/cursor-in app-atom [:packing :packdesk])
              packdesk
              (first
                (filter
                  #(and
                     (= (:ent/uuid %) (:ent/uuid @packdesk-atom))
                     (= (:context/type %) :packing/packdesk))
                  opened))]

          (when-not (contains? opened lref)
            (swap! app-atom update-in [:presence :opened] (fnil conj #{}) lref))

          (swap! app-atom assoc-in [:presence :current-context] (or (:ent/uuid lref) (:ent/ident lref)))

          (when packdesk
            (grid/dispatch-action app-atom :packing/update-packdesk
              {:packing-desk/status :packing-desk.status/closed}))

          (comms/send :presence/open {:context lref}))))
  ;; TODO: Borken paradigm (open + close should be together)
    (grid/close-modal app-atom)
    #?(:cljs
       (do
         (.setTimeout js/window
           (fn []
           ;; async to sync... go figure.
             (async/put! flow-dispatch
               (fn []
                 (swap! app-atom
                   (fn [p]
                     (->
                       p
                       (assoc-in [:page :screen] screen)
                       (update :history add-history screen)))))))
           25)
         (.scrollTo js/window 0 0)))))

;; Simply fire the transition-open for current screen.
(defn transition-load [app-atom]
  #_(println "Transition load" (get-in @app-atom [:page :screen]))
  (let [screen (get-in @app-atom [:page :screen])
        screen-params (cmn/screen-params app-atom)]
    (transition-open app-atom screen screen-params)
    #?(:cljs
       (transition-after-open app-atom screen))))

(defn transition-prev [app-atom & [prev-screen]]
  (let [screen (or prev-screen (last (butlast (get-in @app-atom [:history]))))
        modal-open (grid/modal-open? app-atom)]
    #_(println "Transition back to: " screen)
    ;; TODO: Again, borken paradign (open + close should be together)
    (when modal-open
      (grid/close-modal app-atom))

    (when (and screen (or prev-screen (not modal-open)))
      (transition-next app-atom screen))))

(defn screen-react [app-atom]
  (cmn/curact app-atom [:page :screen]))



(defn setup-transition-listener [app-atom]
  (let [page-atom (rum/cursor-in app-atom [:page])]
    #?(:cljs
       (set! (.-onbeforeunload js/window)
         (fn []
           (if (confirm-leave? app-atom (:screen @page-atom))
             "You may have unsaved work, are you sure you want to leave?"
             nil))))

    (add-watch page-atom ::transition
      (fn [k r o n]
        (when
          (or
            (not= (:screen o) (:screen n))
            (not= (get o (:screen n)) (get n (:screen n))))

          (when (:screen o)
            (transition-close app-atom (:screen o)))

          (let [screen (:screen n)]
          ;; Need to fire this _after_ a transition next is complete.
            (async/put! flow-dispatch
              #(when n
                 (let [screen-params (cmn/screen-params app-atom)]
                   (transition-open app-atom screen screen-params)
                   #?(:cljs
                      (transition-after-open app-atom screen)))))))))))